export enum TodoPermissions {
  VIEW_TO_DO = "view_to_do",
  CREATE_TO_DO = "create_to_do",
  UPDATE_TO_DO = "update_to_do",
  DELETE_TO_DO = "delete_to_do",
}

export const TodoPermissionsText: Record<TodoPermissions, string> = {
  [TodoPermissions.VIEW_TO_DO]: "View To Do",
  [TodoPermissions.CREATE_TO_DO]: "Create To Do",
  [TodoPermissions.UPDATE_TO_DO]: "Update To Do",
  [TodoPermissions.DELETE_TO_DO]: "Delete To Do",
};
